import { render, staticRenderFns } from "./TablesSection.vue?vue&type=template&id=259e3c65"
import script from "./TablesSection.vue?vue&type=script&lang=js"
export * from "./TablesSection.vue?vue&type=script&lang=js"
import style0 from "./TablesSection.vue?vue&type=style&index=0&id=259e3c65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports